module.exports = __webpack_public_path__ + "img/default-browse-vehicles-nissan.982b8fab.png";